import React from 'react'
import { PanelToggle } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  isScheduledSendingState,
  progressState,
  scheduledSendingState
} from '../recoil/states/state'
import { RCS_QUEUING_FAILED, RCS_QUEUING_RUNNING } from 'Api/beRcs'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'
import { STORE_KEY_LIST, useStorage } from 'mailup-react-helpers'

const BoxSheduling = () => {
  const intl = useIntl()
  const [{ isScheduledSending }, setScheduledSending] = useRecoilState(
    scheduledSendingState
  )

  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values
  const { queueStatus } = useRecoilValue(progressState)

  const handleOnChangeToggle = () => {
    setScheduledSending(prev => ({
      ...prev,
      isScheduledSending: !isScheduledSending
    }))
  }

  return (
    <PanelToggle
      onChange={handleOnChangeToggle}
      checked={isScheduledSending}
      title={intl.formatMessage({
        id: 'Load.Rcs.SchedulePanelTitle'
      })}
      data-mu-test='SchedulePanel'
      disabled={
        queueStatus === RCS_QUEUING_RUNNING ||
        queueStatus === RCS_QUEUING_FAILED
      }
    >
      <ContentScheduled
        scheduleTimeZoneCode={listTimeZoneCode}
        // scheduleDate={startDate}
        // scheduleTimeZoneCode={scheduleTimeZoneCode || listTimeZoneCode}
        oneRow
        description={intl.formatMessage({
          id: 'Load.Rcs.SchedulePanelBody'
        })}
      />
    </PanelToggle>
  )
}

export default BoxSheduling
